import { FC } from "react";
import SidebarCasinoFiltersContainer from "components/side-bar/common/casino-filter/SidebarCasinoFiltersContainer";
import styles from "./advanced-sidebar-casino.module.sass";

const AdvancedSidebarCasino: FC = () => {
    return (
        <div className={styles.casinoNav}>
            <SidebarCasinoFiltersContainer filterClassname={styles.advancedFilter} />
        </div>
    );
};

export default AdvancedSidebarCasino;
